"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSHA256Signature = void 0;
const crypto_js_1 = require("crypto-js");
const createSHA256Signature = (data, secretKey) => {
    return (0, crypto_js_1.HmacSHA256)(data, secretKey).toString();
};
exports.createSHA256Signature = createSHA256Signature;
//# sourceMappingURL=Encryption.js.map